import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** Local Date type */
  LocalDate: { input: any; output: any; }
  /** Local Date Time type */
  LocalDateTime: { input: string; output: string; }
  /** Local Time type */
  LocalTime: { input: string; output: string; }
  /** A 64-bit signed integer */
  Long: { input: number; output: number; }
}

/** # MUTATIONS */
export interface Mutation {
  __typename?: 'Mutation';
  /**  АДМИНКА, обновить бизнес правило  */
  updateBusinessRule: PaymentBusinessRuleDto;
  /**  АДМИНКА, обновить правило валидации поля  */
  updateValidationRule: PaymentValidationRuleDto;
}


/** # MUTATIONS */
export interface MutationUpdateBusinessRuleArgs {
  input: UpdatePaymentBusinessRuleDto;
}


/** # MUTATIONS */
export interface MutationUpdateValidationRuleArgs {
  input: UpdatePaymentValidationRuleDto;
}

export interface PaymentBusinessRuleDto {
  __typename?: 'PaymentBusinessRuleDto';
  errorMsg: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  paymentRef: Scalars['String']['output'];
  ruleCondition: RuleCondition;
  ruleTrait: RuleTrait;
  timeValue: Scalars['LocalTime']['output'];
  updateDate: Scalars['LocalDateTime']['output'];
  updatedBy: Scalars['String']['output'];
}

/** # ENUMS */
export enum PaymentPage {
  Cards = 'CARDS',
  Conversion = 'CONVERSION',
  /**  Общее  */
  General = 'GENERAL',
  Qr = 'QR',
  Swift = 'SWIFT',
  /**  Клиринг/Гросс/Внутрибанк  */
  Transfer = 'TRANSFER'
}

/** # DATA */
export interface PaymentValidationRuleDto {
  __typename?: 'PaymentValidationRuleDto';
  field: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isRequired: Scalars['Boolean']['output'];
  maxLength: Maybe<Scalars['String']['output']>;
  message: OutMessageLangDto;
  minLength: Maybe<Scalars['String']['output']>;
  paymentRef: PaymentPage;
  regex: Maybe<Scalars['String']['output']>;
  ruleTrait: RuleTrait;
  updateDate: Scalars['LocalDateTime']['output'];
  updatedBy: Scalars['String']['output'];
}

/** # QUERIES */
export interface Query {
  __typename?: 'Query';
  /**  !!!ПОКА ТОЛЬКО ДЛЯ ПОДДЕРЖКИ РАЗРАБОТЧИКОМ!!! Почистить кэш бизнес правил  */
  clearBusinessRuleCache: Maybe<Scalars['Boolean']['output']>;
  /**  !!!ПОКА ТОЛЬКО ДЛЯ ПОДДЕРЖКИ РАЗРАБОТЧИКОМ!!! Почистить кэш правил валидации  */
  clearValidationRuleCache: Maybe<Scalars['Boolean']['output']>;
  /**  АДМИНКА, получить все бизнес правила  */
  getAllBusinessRules: Array<PaymentBusinessRuleDto>;
  /**  АДМИНКА, получить все правила валидации  */
  getAllValidationRules: Array<PaymentValidationRuleDto>;
  /**  Получить регламент по времени по операциям  */
  getOperationsTimeRule: Scalars['JSON']['output'];
  /**  Получить правила валидации полей для платежа по данной странице  */
  getPaymentValidationRules: Array<PaymentValidationRuleDto>;
  /**  Получить список рабочих дней по типу операции(есть обычные операции и операции 24/7)  */
  getWorkingDays: Array<Scalars['LocalDate']['output']>;
  /**  АДМИНКА, перезапустить правила/файл с правилами  */
  reloadBusinessRules: Maybe<Scalars['Boolean']['output']>;
}


/** # QUERIES */
export interface QueryGetPaymentValidationRulesArgs {
  page: PaymentPage;
}


/** # QUERIES */
export interface QueryGetWorkingDaysArgs {
  isWorkingDay: InputMaybe<Scalars['Boolean']['input']>;
  operation: InputMaybe<Scalars['String']['input']>;
}

export enum RuleCondition {
  /**  Время создания - КОНЕЦ  */
  CreateEndTime = 'CREATE_END_TIME',
  /**  Время создания - НАЧАЛО  */
  CreateStartTime = 'CREATE_START_TIME',
  /**  Время подписания/отправки в АБС - КОНЕЦ  */
  Send2AbsEndTime = 'SEND2ABS_END_TIME',
  /**  Время подписания/отправки в АБС - НАЧАЛО  */
  Send2AbsStartTime = 'SEND2ABS_START_TIME'
}

export enum RuleTrait {
  Aed = 'AED',
  /**  Между картами  */
  Card_2Card = 'CARD_2_CARD',
  /**  Карты на р/с  */
  Card_2Rko = 'CARD_2_RKO',
  Clearing = 'CLEARING',
  Cny = 'CNY',
  /**  Правило общее/по умолчанию  */
  Default = 'DEFAULT',
  Eur = 'EUR',
  Gross = 'GROSS',
  /**  Внутрибанк  */
  Intrabank = 'INTRABANK',
  Invoice = 'INVOICE',
  Kzt = 'KZT',
  /**  Р/с на карты  */
  Rko_2Card = 'RKO_2_CARD',
  Rub = 'RUB',
  Try = 'TRY',
  Usd = 'USD'
}

export interface TimeRuleDto {
  __typename?: 'TimeRuleDto';
  createDeadline: Scalars['String']['output'];
  createIsAllowed: Scalars['Boolean']['output'];
  fromTime: Scalars['String']['output'];
  ruleTrait: RuleTrait;
  signDeadline: Scalars['String']['output'];
  signIsAllowed: Scalars['Boolean']['output'];
}

export interface UpdatePaymentBusinessRuleDto {
  id: Scalars['Long']['input'];
  paymentRef: Scalars['String']['input'];
  ruleCondition: Scalars['String']['input'];
  ruleTrait: Scalars['String']['input'];
  timeValue: Scalars['LocalTime']['input'];
}

/** # INPUT */
export interface UpdatePaymentValidationRuleDto {
  field: Scalars['String']['input'];
  id: Scalars['Long']['input'];
  isRequired: Scalars['Boolean']['input'];
  maxLength: InputMaybe<Scalars['String']['input']>;
  message: InMessageLangDto;
  minLength: InputMaybe<Scalars['String']['input']>;
  paymentRef: PaymentPage;
  regex: InputMaybe<Scalars['String']['input']>;
  ruleTrait: RuleTrait;
}

export interface InMessageLangDto {
  eng: InputMaybe<Scalars['String']['input']>;
  kg: InputMaybe<Scalars['String']['input']>;
  ru: InputMaybe<Scalars['String']['input']>;
}

export interface OutMessageLangDto {
  __typename?: 'outMessageLangDto';
  /**  китайский язык */
  cn: Maybe<Scalars['String']['output']>;
  eng: Maybe<Scalars['String']['output']>;
  kg: Maybe<Scalars['String']['output']>;
  ru: Maybe<Scalars['String']['output']>;
}

export type MessageLangFragment = { __typename?: 'outMessageLangDto', ru: string | null, eng: string | null, kg: string | null, cn: string | null };

export type PaymentValidationRuleFragment = { __typename?: 'PaymentValidationRuleDto', id: number, field: string, regex: string | null, minLength: string | null, maxLength: string | null, paymentRef: PaymentPage, ruleTrait: RuleTrait, isRequired: boolean, message: { __typename?: 'outMessageLangDto', ru: string | null, eng: string | null, kg: string | null, cn: string | null } };

export type TimeRuleFragment = { __typename?: 'TimeRuleDto', createIsAllowed: boolean, createDeadline: string, signDeadline: string, ruleTrait: RuleTrait, fromTime: string, signIsAllowed: boolean };

export type GetPaymentValidationRulesByPageQueryVariables = Exact<{
  page: PaymentPage;
}>;


export type GetPaymentValidationRulesByPageQuery = { __typename?: 'Query', getPaymentValidationRules: Array<{ __typename?: 'PaymentValidationRuleDto', id: number, field: string, regex: string | null, minLength: string | null, maxLength: string | null, paymentRef: PaymentPage, ruleTrait: RuleTrait, isRequired: boolean, message: { __typename?: 'outMessageLangDto', ru: string | null, eng: string | null, kg: string | null, cn: string | null } }> };

export type GetWorkingDaysQueryVariables = Exact<{
  isWorkingDay: InputMaybe<Scalars['Boolean']['input']>;
  operation: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkingDaysQuery = { __typename?: 'Query', getWorkingDays: Array<any> };

export type GetOperationsTimeRuleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOperationsTimeRuleQuery = { __typename?: 'Query', getOperationsTimeRule: any };

export type GetRuleOptionsQueryVariables = Exact<{
  page: PaymentPage;
  isWorkingDay: InputMaybe<Scalars['Boolean']['input']>;
  operation: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRuleOptionsQuery = { __typename?: 'Query', getWorkingDays: Array<any>, getOperationsTimeRule: any, getPaymentValidationRules: Array<{ __typename?: 'PaymentValidationRuleDto', id: number, field: string, regex: string | null, minLength: string | null, maxLength: string | null, paymentRef: PaymentPage, ruleTrait: RuleTrait, isRequired: boolean, message: { __typename?: 'outMessageLangDto', ru: string | null, eng: string | null, kg: string | null, cn: string | null } }> };

export type GetTimeRuleOptionsQueryVariables = Exact<{
  isWorkingDay: InputMaybe<Scalars['Boolean']['input']>;
  operation: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTimeRuleOptionsQuery = { __typename?: 'Query', getWorkingDays: Array<any>, getOperationsTimeRule: any };

export const MessageLangFragmentDoc = gql`
    fragment MessageLang on outMessageLangDto {
  ru
  eng
  kg
  cn
}
    `;
export const PaymentValidationRuleFragmentDoc = gql`
    fragment PaymentValidationRule on PaymentValidationRuleDto {
  id
  field
  regex
  minLength
  maxLength
  paymentRef
  ruleTrait
  isRequired
  message {
    ...MessageLang
  }
}
    ${MessageLangFragmentDoc}`;
export const TimeRuleFragmentDoc = gql`
    fragment TimeRule on TimeRuleDto {
  createIsAllowed
  createDeadline
  signDeadline
  ruleTrait
  fromTime
  signIsAllowed
}
    `;
export const GetPaymentValidationRulesByPageDocument = gql`
    query getPaymentValidationRulesByPage($page: PaymentPage!) {
  getPaymentValidationRules(page: $page) {
    ...PaymentValidationRule
  }
}
    ${PaymentValidationRuleFragmentDoc}`;
export const GetWorkingDaysDocument = gql`
    query getWorkingDays($isWorkingDay: Boolean, $operation: String) {
  getWorkingDays(isWorkingDay: $isWorkingDay, operation: $operation)
}
    `;
export const GetOperationsTimeRuleDocument = gql`
    query getOperationsTimeRule {
  getOperationsTimeRule
}
    `;
export const GetRuleOptionsDocument = gql`
    query getRuleOptions($page: PaymentPage!, $isWorkingDay: Boolean, $operation: String) {
  getPaymentValidationRules(page: $page) {
    ...PaymentValidationRule
  }
  getWorkingDays(isWorkingDay: $isWorkingDay, operation: $operation)
  getOperationsTimeRule
}
    ${PaymentValidationRuleFragmentDoc}`;
export const GetTimeRuleOptionsDocument = gql`
    query getTimeRuleOptions($isWorkingDay: Boolean, $operation: String) {
  getWorkingDays(isWorkingDay: $isWorkingDay, operation: $operation)
  getOperationsTimeRule
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getPaymentValidationRulesByPage(variables: GetPaymentValidationRulesByPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentValidationRulesByPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentValidationRulesByPageQuery>(GetPaymentValidationRulesByPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentValidationRulesByPage', 'query', variables);
    },
    getWorkingDays(variables?: GetWorkingDaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetWorkingDaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWorkingDaysQuery>(GetWorkingDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWorkingDays', 'query', variables);
    },
    getOperationsTimeRule(variables?: GetOperationsTimeRuleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOperationsTimeRuleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOperationsTimeRuleQuery>(GetOperationsTimeRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOperationsTimeRule', 'query', variables);
    },
    getRuleOptions(variables: GetRuleOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRuleOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRuleOptionsQuery>(GetRuleOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRuleOptions', 'query', variables);
    },
    getTimeRuleOptions(variables?: GetTimeRuleOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTimeRuleOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTimeRuleOptionsQuery>(GetTimeRuleOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTimeRuleOptions', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;